import * as fs from "node:fs";
import * as os from "node:os";
import * as path from "node:path";
import { parse as parseYaml } from "yaml";
import { LocalCliError } from "./errors.js";

const A2A_PATH = "/api/a2a/mcp";

/** Resolve the full A2A bridge URL (<gateway-base>/api/a2a/mcp).
 *  Precedence: --gateway-url flag → M8T_GATEWAY_URL env → ~/.m8t/config.yaml gatewayUrl. */
export function resolveBridgeUrl(opts: { flag?: string; env?: NodeJS.ProcessEnv; home?: string }): string {
  const env = opts.env ?? process.env;
  const base =
    clean(opts.flag) ??
    clean(env.M8T_GATEWAY_URL) ??
    clean(readConfigGatewayUrl(opts.home));
  if (!base) {
    throw new LocalCliError({
      code: "A2A_NO_GATEWAY_URL",
      message: "Could not resolve the gateway URL for the A2A bridge.",
      hint: "Pass --gateway-url https://<gateway-fqdn>, set M8T_GATEWAY_URL, or add a gatewayUrl key to ~/.m8t/config.yaml.",
    });
  }
  return `${base}${A2A_PATH}`;
}

function clean(v: string | undefined): string | undefined {
  if (!v || typeof v !== "string") return undefined;
  let t = v.trim().replace(/\/+$/, "");
  // Tolerate a full bridge URL being passed (with or without the path) — strip a
  // trailing A2A_PATH so resolveBridgeUrl appends it exactly once (no doubling).
  if (t.toLowerCase().endsWith(A2A_PATH)) t = t.slice(0, -A2A_PATH.length).replace(/\/+$/, "");
  return t.length ? t : undefined;
}

function readConfigGatewayUrl(home?: string): string | undefined {
  const cfg = path.join(home ?? os.homedir(), ".m8t", "config.yaml");
  if (!fs.existsSync(cfg)) return undefined;
  try {
    const o = parseYaml(fs.readFileSync(cfg, "utf8")) as Record<string, unknown>;
    return typeof o.gatewayUrl === "string" ? o.gatewayUrl : undefined;
  } catch {
    return undefined;
  }
}
